var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-division-config-panel" },
    [
      _c("el-divider", { attrs: { "content-position": "left" } }, [
        _vm._v("分账信息"),
      ]),
      _c("el-alert", {
        staticClass: "user-division-config-panel__alert",
        attrs: {
          title: "基础资料保存与分账配置保存分离，请分别点击对应按钮完成提交。",
          type: "info",
          closable: false,
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
        },
        [
          _vm.hasUserId
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.form,
                        "label-width": "120px",
                        size: "small",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "计全付接收方ID" } },
                        [
                          _c("el-input", {
                            staticClass: "user-division-config-panel__input",
                            attrs: {
                              maxlength: "64",
                              clearable: "",
                              placeholder: "请输入计全付接收方ID",
                            },
                            model: {
                              value: _vm.form.jeequanReceiverId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "jeequanReceiverId",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.jeequanReceiverId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "绑定状态" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.statusTagType(
                                  _vm.detail.receiverBindStatus
                                ),
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.statusText(
                                      _vm.detail.receiverBindStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "接收方别名" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.displayValue(_vm.detail.receiverAlias))
                          ),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "上游接收方ID" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.displayValue(_vm.detail.providerReceiverId)
                            )
                          ),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "最后同步时间" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.formatTime(_vm.detail.lastSyncTime))
                          ),
                        ]),
                      ]),
                      _vm.showFailReason
                        ? _c("el-form-item", { attrs: { label: "失败原因" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.displayValue(
                                    _vm.detail.receiverFailReason
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { staticClass: "user-division-config-panel__actions" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["platform:user:update"],
                                  expression: "['platform:user:update']",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                size: "small",
                                loading: _vm.saveLoading,
                              },
                              on: { click: _vm.handleSave },
                            },
                            [_vm._v(" 保存分账信息 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", { staticClass: "user-division-config-panel__empty" }, [
                _vm._v(" 请先保存用户基础资料，再维护分账配置。 "),
              ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }